<template>
    <article class="dml-product-details"
             :data-redirect-url="redirectUrl"
             v-bind:class="{'dml-product-details--lightbox' : isLightbox}">
        <div class="dml-product-details__wrapper">
            <div v-if="!isLightbox" class="dml-category-header">
                <a :href="categoryUrl"
                   data-ga="m_product_page.click"
                   data-ga-label="back_to_category"
                   class="dml-category-header__fade">
                    <div class="dml-category-header__title _bc _th4">
                        <dm-icon name="angle-left" :width="24" :height="24" />
                        <span class="_spll">Idź do <strong>{{ categoryName }}</strong></span>
                    </div>
                </a>
            </div>
            <div class="dml-product-details__container">
                <div class="dml-product-details__column">
                    <div v-if="like"
                         class="dml-product-details__like _bc"
                         v-on:click="trackEvent('like')">
                        <dm-like-button :model="like" />
                    </div>
                    <div v-if="isActive" class="dml-product-details__gallery">
                        <div class="dml-product-details__gallery-wrapper">
                            <swiper ref="swiper" :options="swiperOption" :key="productId" v-observe="updateSwiper">
                                <swiper-slide v-for="(image, index) in galleryModel" :key="`${productId}_${index}`" data-t="12.2">
                                    <span v-on:click="redirect(`image_${index + 1}`)"
                                          class="_cp">
                                        <img v-if="isLightbox"
                                             :src="image.imageUrl"
                                             :srcset="gallerySrcset[index]"
                                             sizes="(min-width: 720px) 24vw, 47vw"
                                             :data-srcset="`${image.smallImage} 220w,
                                                            ${image.mediumImage} 275w,
                                                            ${image.largeImage} 350w`"
                                             data-sizes="(min-width: 720px) 35vw, 53vw"
                                             :alt="image.alt"
                                             :title="image.title"
                                             class="lazy" />
                                        <img v-else
                                             :src="image.imageUrl"
                                             :srcset="('data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAHCAQAAABqrk9lAAAADklEQVR42mNkgANGipkAAYEACAqFE8kAAAAASUVORK5CYII=')"
                                             :data-srcset="`${image.smallImage} 220w,
                                                            ${image.mediumImage} 275w,
                                                            ${image.largeImage} 350w`"
                                             data-sizes="(min-width: 720px) 35vw, 53vw"
                                             :alt="image.name"
                                             :title="image.title"
                                             class="lazy" />
                                    </span>
                                </swiper-slide>
                                <div class="dml-product-details__pagination swiper-pagination _twb" slot="pagination"></div>
                                <div v-show="showGalleryNavigation" class="swiper-button-prev" slot="button-prev">
                                    <dm-icon class="dml-product-details__button-prev" name="angle-left" :width="24" :height="24" />
                                </div>
                                <div v-show="showGalleryNavigation" class="swiper-button-next" slot="button-next">
                                    <dm-icon class="dml-product-details__button-next" name="angle-right" :width="24" :height="24" />
                                </div>
                            </swiper>
                            <span v-on:click="redirect"
                                  class="_cp">
                                <dm-product-details-labels v-bind="labelsModel"
                                                           class="dml-product-details__labels" />
                            </span>
                        </div>
                    </div>
                    <div v-else class="dml-product-details__images-list">
                        <span class="dml-product-details__images-list-title">Produkt niedostępny</span>
                        <div v-for="image in galleryModel" class="dml-product-details__images-list-item">
                            <img :srcset="image.imageUrl"
                                 :src="image.imageSrc"
                                 :alt="image.alt" />
                        </div>
                    </div>
                </div>

                <div class="dml-product-details__column">
                    <div class="dml-product-details__price-title">
                        <div class="dml-product-details__title-section">
                            <span v-if="productName"
                               class="dml-product-details__subtitle _cp"
                               v-on:click="redirect('brand_name')">
                                {{productName}}
                            </span>
                            <h1 class="dml-product-details__title _to2">
                                <span v-if="isActive"
                                   v-on:click="redirect('product_name')"
                                   class="_cp">
                                    {{ title }}
                                </span>
                                <span v-else>
                                    {{ title }}
                                </span>
                            </h1>
                        </div>
                        <div class="dml-product-details__price--box" v-if="isActive" v-on:click="redirect('price')">
                            <template v-if="price.isPromo">
                                <div class="dml-price-wrap dml-product-details__price _cp">
                                    <span class="dml-price dml-price--promo">{{ price.promo }}</span>
                                    <span class="dml-price dml-price--old">{{ price.regular }}*</span>
                                </div>
                                <span class="dml-product-details__omnibus _cp">*najniższa cena w okresie 30 dni przed obniżką</span>
                            </template>
                            <span v-else class="dml-price dml-price--regular">{{ price.promo }}</span>
                        </div>
                    </div>
                    <div v-if="isActive"
                         ref="cta"
                         class="dml-product-details__button dml-product-details__button--main">
                        <span class="btn btn--cta _bc _jcsb _shadow-big _cp"
                           v-on:click="redirect('CTA')">
                            <span class="dml-product-details__cta-text">
                                Zobacz w sklepie
                                <span class="_twb">
                                    {{ shopname }}
                                </span>
                            </span>
                            <dm-icon name="arrow-right-long" :width="29" :height="16" />
                        </span>
                    </div>
                    <a v-else-if="productsUrlForInactiveProduct" :href="productsUrlForInactiveProduct" class="btn btn--secondary btn--max _bc _shadow-big dml-product-details__button">
                        <span class="_to">{{productsButtonTextForInactiveProducts}}</span>
                    </a>
                    <template v-if="isActive">
                        <div v-if="sizes && sizes.length"
                             class="dml-product-details__sizes-wrapper">
                            <ul class="dml-product-details__sizes list">
                                <li v-for="item in sizes" class="dml-product-details__size">
                                    <span v-on:click="redirect('size')"
                                          class="_cp">
                                        {{ item }}
                                    </span>
                                </li>
                            </ul>
                        </div>
                        <span v-if="showShipping"
                           v-on:click="redirect('shipping')"
                           class="dml-product-details__info-wrapper _cp">
                            <span v-if="shipping"
                                  :class="['dml-product-details__info', {'dml-product-details__info--free-shipping': freeShipping}]">
                                <dm-icon class="dm-symbol _smur" name="truck-fill" :width="24" :height="24" />
                                {{ shipping }}
                            </span>
                            <template v-if="shippingDetails">
                                <span v-if="shippingDetails.deferredPaymentMessage"
                                      v-on:click="trackEvent('deferred_payment')"
                                      class="dml-product-details__info">
                                    <dm-icon class="dm-symbol _smur" name="deferred-payment" :width="24" :height="24" />
                                    {{shippingDetails.deferredPaymentMessage}}
                                </span>
                                <span v-if="shippingDetails.shippingTimeMessage"
                                      v-on:click="trackEvent('shipping_time')"
                                      class="dml-product-details__info">
                                    <dm-icon class="dm-symbol _smur" name="time" :width="24" :height="24" />
                                    {{shippingDetails.shippingTimeMessage}}
                                </span>
                                <span v-if="shippingDetails.returnsPolicyMessage"
                                      v-on:click="trackEvent('shipping_return')"
                                      class="dml-product-details__info">
                                    <dm-icon class="dm-symbol _smur" name="return" :width="24" :height="20" />
                                    {{shippingDetails.returnsPolicyMessage}}
                                </span>
                            </template>
                            <span v-if="dropshippingSettings"
                                  class="dml-product-details__info dml-product-details__info--long"
                                  v-on:click="trackEvent('dropshipping')">
                                <dm-icon class="dm-symbol _smur text-link" name="exclamation-circle" :width="18" :height="18" />
                                <span class="dml-product-details-info">
                                    <strong class="dml-product-details-info__title">
                                        {{dropshippingSettings.deliveryTimeInfo}}
                                    </strong>
                                    <span class="dml-product-details-info__desc">
                                        Wydłużony czas dostawy
                                    </span>
                                </span>
                            </span>
                        </span>
                    </template>
                    <dm-coupon-details v-if="coupon"
                                       class="_smdt _smlb"
                                       v-on:getCoupon="getCoupon"
                                       v-on:redirectCoupon="redirectCoupon"
                                       :url="redirectUrl"
                                       :target="mobileTarget"
                                       :model="coupon"
                                       :couponContent="couponContent"
                                       :showContent="showCouponContent"
                                       ref="coupon"
                                       :productId="productId" />
                </div>
            </div>

            <div class="dml-product-description" v-show="isLoaded || !isLightbox">
                <span :class="['dml-product-description__title', '_cp' , {'dml-product-description__title--collapsed': !descriptionVisible}]"
                   v-on:click="handleDescriptionClicked"
                   data-t="17.1">
                    <span>Opis produktu</span>
                    <dm-icon class="dm-symbol" :name="descriptionArrow" :width="16" :height="16" />
                </span>
                <div v-show="descriptionVisible" class="dml-product-description__content">
                    <div class="_splv _spuh">
                        <p v-if="brandModel && brandModel.brandName" class="_smhb">{{brandModel.brandName}}</p>
                        <p v-if="shortDescription" class="_twb _th2">{{ shortDescription }}</p>
                        <p v-if="description" v-html="description" class="_links-container"></p>
                        <template v-if="tagGroups">
                            <h3 class="_twb _smhb">Szczegóły produktu:</h3>
                            <ul class="list list--table">
                                <template v-for="tagGroup in tagGroups">
                                    <li class="_dfl">
                                        <span class="text-light _2of5">{{ tagGroup.name }}:</span>
                                        <span class="_3of5">{{ tagGroup.commaSeparatedTags }}</span>
                                    </li>
                                </template>
                            </ul>
                        </template>
                    </div>
                </div>
            </div>
            <div v-if="showSimilarButtons()">
                <ul class="dml-category-links__list _smdh _bc">
                    <li class="dml-category-links__item">
                        <a href="#splendi">Podobne produkty</a>
                    </li>
                    <li class="dml-category-links__item">
                        <a href="#splendiStylist">Z czym nosić?</a>
                    </li>
                </ul>
            </div>
            <div class="dml-product-details__products" v-for="section in recommendedSections">
                <div class="dml-product-details__products-title">
                    <h2 class="_th5 _to _smub _twb" :id="section.name">
                        {{section.title}}
                    </h2>
                </div>

                <dm-scrollable-list className="dml-horizontal-product-list"
                                    innerClassName="dml-horizontal-product-list__list"
                                    navClassName="dml-horizontal-product-list__nav"
                                    :itemsInViewport="4"
                                    :columnsTotal="section.products.length"
                                    v-on:scroll.once="handleRecommendedScroll(section.name)">
                    <template slot="items">
                        <li v-for="item in section.products"
                            v-on:click="trackEvent(`${section.name}_${item.productId}`, 'recommended_product_click')"
                            class="dml-horizontal-product-list__product">
                            <dm-product-item :model="item" :inLightbox="isLightbox" />
                        </li>
                    </template>
                </dm-scrollable-list>
            </div>

            <dm-page-preloader :isLoading="isLoading" :isStatic="isLoaderStatic" :isFailed="isFetchingFailed" />

            <div class="_spdv _splh" v-if="categoriesDescriptionModel && categoriesDescriptionModel.categoryHeader">
                <div class="_spub">
                    <h2 class="_twb _dot _tac">Przeglądaj {{categoriesDescriptionModel.categoryHeader}}</h2>
                    <a :href="categoriesDescriptionModel.ctaUrl"
                       v-on:click="trackEvent('virtual_category_more_products')"
                       class="btn btn--secondary btn--max _bc _shadow-big dml-product-details__button _smlt">
                        <span class="_to">Zobacz {{categoriesDescriptionModel.ctaText}}</span>
                    </a>
                </div>
                <div v-if="categoriesDescriptionModel.links && categoriesDescriptionModel.links.length">
                    <h2 class="_twb _dot _tac _smdt">Zobacz inne {{categoriesDescriptionModel.linkHeader}}</h2>
                    <ul class="dml-list dml-list--dot _twb">
                        <li v-for="link in categoriesDescriptionModel.links">
                            <a :href="link.value">{{link.key}}</a>
                        </li>
                    </ul>
                </div>
            </div>

            <template v-if="brandModel && brandModel.brandName">
                <div class="_spdt _splh">
                    <a v-if="brandModel.brandLogo"
                       :href="brandModel.brandUrl"
                       v-on:click="trackEvent('brand_logo')"
                       class="_bc _spuv">
                        <img :src="brandModel.brandLogo.pictureUrl" :alt="brandModel.brandLogo.alt">
                    </a>
                    <h2 class="_twb _tac _smdt">
                        <a :href="brandModel.brandUrl"
                           v-on:click="trackEvent('brand_logo')"
                           class="_bc _spuv _dot">
                            Marka {{brandModel.brandName}}
                        </a>
                    </h2>
                </div>

                <div class="_spdb _splh">
                    <a :href="brandModel.brandProductsUrl"
                       v-on:click="trackEvent('brand_more_products')"
                       class="btn btn--secondary btn--max _bc _shadow-big dml-product-details__button _smlt">
                        <span v-if="isActive" class="_to"> Zobacz wszystkie {{categoryName}} {{brandModel.brandName}}</span>
                        <span v-else class="_to">Zobacz wszystkie produkty {{brandModel.brandName}}</span>
                    </a>
                </div>
            </template>

            <div v-if="trends">
                <h2 class="_twb _dot _tac _smlb _splt">Zainspiruj się</h2>
                <dm-article :articles="articles" :squareTiles="true" v-on:articleClicked="handleArticleClicked" />
                <div class="_spdb _splh">
                    <a href="/trendy"
                       v-on:click="trackEvent('trends')" rel="nofollow"
                       class="btn btn--secondary btn--max _bc _shadow-big dml-product-details__button _smlt">
                        <span class="_to">Zobacz wszystkie artykuły</span>
                    </a>
                </div>
            </div>
        </div>
    </article>
</template>
<script>
    import { swiper, swiperSlide } from 'vue-awesome-swiper';

    import CategoryHeaderComponent from '../product-list/category-header-component.vue';
    import ProductItemComponent from '../product-list/product-item-component.vue';
    import ProductDetailsLabels from './product-details-labels-component.vue';
    import LikeButton from '../product-list/like-button-component.vue';
    import PagePreloader from '../shared/page-preloader-component.vue';
    import IconComponent from '../shared/icon-component.vue';
    import CouponDetails from '../coupons/coupon-details-component.vue';
    import ArticleComponent from '../adjustable-content/article-component.vue';
    import ScrollableListComponent from '../shared/scrollable-list-component.vue';

    import * as types from '../../store/types.js';
    import Hub from '../../hub.js';
    import DateFormatter from '../../utils/date-formatter.js';
    import { SIZES } from '../../utils/screen-sizes.js';
    import { WP } from '../../trackers/wp.js';
    import trackers from '@trackers';
    import observe from '~/directives/observe.js';
    import throttle from '~/utils/throttle.js';
    import isInViewport from '~/utils/in-view-port.js';

    const CouponTrackAction = {
        OPEN: {
            Grafana: 'CouponComponent.OpenClick',
            GA: 'click_open'
        },
        CONDITIONS: {
            Grafana: 'CouponComponent.ConditionsClick',
            GA: 'click_conditions'
        },
        REDIRECT: {
            Grafana: 'CouponComponent.RedirectClick',
            GA: 'click_redirect'
        }
    };

    export default {
        name: 'dm-product-details',
        components: {
            'dm-category-header': CategoryHeaderComponent,
            'dm-product-item': ProductItemComponent,
            'dm-coupon-details': CouponDetails,
            'dm-article': ArticleComponent,
            'dm-like-button': LikeButton,
            'dm-page-preloader': PagePreloader,
            'dm-icon': IconComponent,
            'dm-product-details-labels': ProductDetailsLabels,
            'dm-scrollable-list': ScrollableListComponent,
            swiper,
            swiperSlide
        },
        directives: {
            observe: observe
        },
        props: {
            promoSaleBadgeImageUrl: String,
            promoSaleBadgeLargeImageUrl: String,
            brand: Object,
            brandModel: Object,
            categoryName: String,
            categoriesDescriptionModel: Object,
            categoryUrl: String,
            coupon: Object,
            description: String,
            tagGroups: Array,
            discountPercent: String,
            productId: Number,
            galleryModel: Array,
            initialGalleryModel: Object,
            isActive: Boolean,
            isInPromoSales: Boolean,
            isNewProduct: Boolean,
            isBestseller: Boolean,
            isDiscountHunters: Boolean,
            isLastItems: Boolean,
            isLightbox: {
                type: Boolean,
                default: true
            },
            isLoading: {
                type: Boolean,
                default: true
            },
            isLoaded: Boolean,
            like: Object,
            mainCategory: Object,
            mobileTarget: String,
            price: Object,
            position: Number,
            productName: String,
            productSections: Array,
            redirectUrl: String,
            shopname: String,
            shopId: Number,
            shipping: String,
            shippingDetails: Object,
            dropshippingSettings: Object,
            shortDescription: String,
            sizes: Array,
            title: String,
            trackers: Object,
            trends: Array,
            url: String,
            productsUrlForInactiveProduct: String,
            productsButtonTextForInactiveProducts: String,
            freeShipping: Boolean
        },
        computed: {
            showDescriptionSection() {
                return this.shortDescription || this.description || this.tagGroups;
            },
            eventCategory() {
                const device = window.innerWidth >= SIZES.LARGE ? 'd' : 'm';
                const place = this.isLightbox ? 'lightbox' : 'product_page';
                return `${device}_${place}`;
            },
            showGalleryNavigation() {
                return this.galleryModel && this.galleryModel.length > 1;
            },
            articles() {
                return this.trends.map(trend => {
                    return Object.assign({}, trend, { teaser: trend.title });
                });
            },
            recommendedSections() {
                if (!this.productSections) {
                    return null;
                } else {
                    return this.showAllProducts ? this.productSections : this.productSections.map(item => {
                        const products = item.products.slice(0, 10);
                        return { ...item, products };
                    });
                }
            },
            gallerySrcset() {
                const emptyImage = 'data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAHCAQAAABqrk9lAAAADklEQVR42mNkgANGipkAAYEACAqFE8kAAAAASUVORK5CYII=';
                const firstImageSet = this.initialGalleryModel ?
                    `${this.initialGalleryModel.smallImage} 185w,
                     ${this.initialGalleryModel.mediumImage} 245w,
                     ${this.initialGalleryModel.largeImage} 335w`
                    : emptyImage;

                return this.galleryModel.reduce((accumulator, current, index) => ({ ...accumulator, [index]: index === 0 ? firstImageSet : emptyImage }), {});
            },
            descriptionArrow() {
                return this.descriptionVisible ? 'angle-up' : 'angle-down';
            },
            isLoaderStatic() {
                return !!this.productName;
            },
            isFetchingFailed() {
                return !this.isLoading && !this.isLoaded && this.isLightbox && !this.isLoaderStatic;
            },
            showShipping() {
                return this.shipping || this.shippingDetails || this.dropshippingSettings;
            },
            showLabels() {
                return this.isInPromoSales || this.discountPercent || this.isNewProduct || this.isBestseller || this.isLastItems;
            },
            labelsModel() {
                return {
                    isNewProduct: this.isNewProduct,
                    isBestseller: this.isBestseller,
                    isDiscountHunters: this.isDiscountHunters,
                    isLastItems: this.isLastItems,
                    isInPromoSales: this.isInPromoSales,
                    dataGA: `${this.eventCategory}.click`,
                    discountPercent: this.discountPercent,
                    promoSale: this.promoSale
                }
            },
            promoSale() {
                if (this.promoSaleBadgeImageUrl && this.promoSaleBadgeLargeImageUrl) {
                    return {
                        badgeImageUrl: this.promoSaleBadgeImageUrl,
                        badgeLargeImageUrl: this.promoSaleBadgeLargeImageUrl
                    }
                }

                return null;
            },
            priceValue() {
                return parseFloat(this.price.promo.replace(',', '.').replace('zł', '').trim());
            },
        },
        data() {
            return {
                showAllProducts: false,
                couponContent: {},
                showCouponContent: false,
                descriptionVisible: false,
                swiperOption: {
                    touchStartPreventDefault: false,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        type: 'fraction'
                    },
                    on: {
                        slidePrevTransitionStart: () => {
                            this.trackEvent('image_prev');
                        },
                        slideNextTransitionStart: () => {
                            this.trackEvent('image_next');
                        }
                    }
                },
                emptyImage: 'data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAHCAQAAABqrk9lAAAADklEQVR42mNkgANGipkAAYEACAqFE8kAAAAASUVORK5CYII=',
            };
        },
        mounted() {
            if (this.isLoaded && this.trackers) {
                this.trackEvent(this.shopId, 'open_lightbox');
                this.track();
                this.handleCouponsVisibility();
            }
            if (this.productSections) {
                this.trackEvent(this.shopId, 'recommendations_loaded');
            }

            this.$emit('mounted');
        },
        watch: {
            isLoaded(current) {
                this.resetDescriptionVisible();
                if (current) {
                    this.trackEvent(this.shopId, 'open_lightbox');
                    if (this.trackers) {
                        this.track();
                    }
                }
                this.handleCouponsVisibility();
            },
            productSections(current) {
                if (current) {
                    this.trackEvent(this.shopId, 'recommendations_loaded');
                }
            },
        },
        methods: {
            redirect() {
                if (this.mobileTarget === '_blank') {
                    window.open(this.redirectUrl, '_newtab' + Math.floor(Math.random() * 999999));
                } else {
                    window.location = this.redirectUrl;
                }
            },
            handleCouponsVisibility() {
                if (this.$store.getters.expandedCouponId === this.productId) {
                    this.getCoupon();

                    window.setTimeout(() => {
                        const scrollY = this.$refs.coupon.$el.getBoundingClientRect().top + window.scrollY - 200;
                        window.scrollTo({
                            top: scrollY,
                            behavior: 'smooth'
                        });
                    }, 0);
                } else {
                    this.couponContent = {};
                    this.showCouponContent = false;
                    this.$store.commit(types.SET_EXPANDED_COUPON_ID, null);
                }
            },
            handleRecommendedScroll(label) {
                this.showAllProducts = true;
                this.trackEvent(label, 'recommended_products_scroll');
            },
            track() {
                this.trackFbEvent('track', 'ViewContent', {
                    content_ids: [this.productId],
                    content_type: 'product',
                    products_category: this.categoryName,
                    products_name: this.title,
                    products_brand: this.brand ? this.brand.name : '',
                    products_price: this.priceValue,
                    shop_id: this.shopId,
                    shop_name: this.shopname
                });

                if (this.trackers.facebook) {
                    this.trackFbEvent('track', 'CompleteRegistration', {
                        ...this.trackers.facebook.facebookJson
                    });
                }

                if (this.trackers.wp) {
                    const wp = new WP('product_view');
                    wp.trackEvent(this.trackers.wp);
                }

                if (this.trackers.googleTagManager) {
                    const { productId } = this;
                    const { googleTagManager } = this.trackers;

                    window.WP.push(function () {
                        window.WP.gdpr.runAfterConsent(function () {
                            const gtmParams = {
                                event: 'dm_event_view',
                                dm_ecomm_pagetype: 'cart',
                                dm_productId: productId,
                                dm_pageType: 'LightboxDetails',
                                dm_custom_url: `/product/${productId}`,
                                ...googleTagManager
                            };

                            //clear dataLayer key: dm_dynx_itemid
                            DM.Utils.trackGTM({ 'dm_dynx_itemid': undefined });
                            DM.Utils.trackGTM(gtmParams);
                        });
                    });
                }

                trackers.track('productLightboxView', {
                    productName: this.title,
                    productId: this.productId,
                    price: this.priceValue,
                    brand: this.brand ? this.brand.name : null,
                    categoryName: this.mainCategory && this.mainCategory.categoryName ? this.mainCategory.categoryName : '',
                    categoryId: this.mainCategory && this.mainCategory.categoryId && this.mainCategory.categoryId.toString(),
                    isActive: this.isActive,
                    ...this.trackers.qGraph
                });
            },
            handleDescriptionClicked() {
                this.descriptionVisible = !this.descriptionVisible;
                this.trackEvent(this.descriptionVisible ? 'expand' : 'collapse', 'description_click');
            },
            getCoupon() {
                const data = {
                    id: parseInt(this.coupon.id),
                    url: this.url,
                    productId: this.productId
                };

                this.showCouponContent = true;

                DM.Service.Coupon.getCoupon(data.id, data.productId).then((res) => {
                    this.couponContent = Object.assign(data, res);
                    this.trackFacebookCoupon(res);
                    this.trackCoupon(CouponTrackAction.OPEN, res.id);
                }).catch(() => {
                    this.showCouponContent = false;
                });
            },
            redirectCoupon(id) {
                this.trackCoupon(CouponTrackAction.REDIRECT, id);
                this.redirect();
            },
            trackFacebookCoupon(res) {
                const formatter = new DateFormatter();
                const time = formatter.dateToDMY(new Date(res.validTo));
                const parameters = {
                    content_type: 'product',
                    discount: res.value,
                    price: this.price.promo,
                    currency: 'PLN',
                    value: 0.00,
                    content_ids: this.productId,
                    product_name: this.title,
                    time,
                    is_discounted: this.discountPercent != null,
                    dada: res.shopId,
                    couponcode_id: res.id
                };

                this.trackFbEvent('trackCustom', 'CouponCode', parameters)
            },
            trackFbEvent(type, name, params) {
                if (window.fbq) {
                    window.WP.push(function () {
                        window.WP.gdpr.runAfterConsent(function () {
                            if (window.WP.gdpr.check('mr', 'TP')) {
                                window.fbq(type, name, params);
                            }
                        });
                    });
                }
            },
            trackEvent(label, action = 'click') {
                this.$ga.trackEvent({
                    category: this.eventCategory,
                    action,
                    label
                });
            },
            trackCoupon(trackAction, code) {
                Hub.publish(Hub.TRACK_GRAFANA, trackAction.Grafana);
                this.$ga.trackEvent({
                    category: 'coupon_code',
                    action: trackAction.GA,
                    label: code
                });
            },
            resetDescriptionVisible() {
                this.descriptionVisible = false;
            },
            updateSwiper() {
                if (!this.isLightbox) {
                    this.$refs.swiper.update();
                }
            },
            handleArticleClicked(title) {
                this.trackEvent(title, 'click_article_cover');
            },
            showSimilarButtons(){
                if (!this.recommendedSections) {
                    return false;
                }
                return this.recommendedSections.filter(r => r.name === 'splendi' || r.name === 'splendiStylist').length === 2;
            }
        },
    };
</script>
